import { render, staticRenderFns } from "./HubRequirements.vue?vue&type=template&id=31077a1b&scoped=true"
import script from "./HubRequirements.vue?vue&type=script&lang=js"
export * from "./HubRequirements.vue?vue&type=script&lang=js"
import style0 from "./HubRequirements.vue?vue&type=style&index=0&id=31077a1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31077a1b",
  null
  
)

export default component.exports